import React from "react";

const Announcement = () => {
  return (
    <div className="announcement-container">
      Super Deal! Free Shipping on Orders Over $50
    </div>
  );
};

export default Announcement;
